(function () {
  if (customElements.get('pp-collection')) return;

  class PpCollection extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-pp-filter-form]');

      const toggle = this.querySelector('[data-pp-desc-toggle]');
      if (toggle) {
        toggle.addEventListener('click', () => {
          const desc = this.querySelector('[data-pp-desc]');
          const open = desc.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          toggle.textContent = open ? toggle.dataset.less : toggle.dataset.more;
        });
      }

      const sort = this.querySelector('[data-pp-sort]');
      if (sort) {
        sort.addEventListener('change', () => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', sort.value);
          url.searchParams.delete('page');
          this.go(url);
        });
      }

      if (this.form) {
        // Checkboxes apply straight away; price inputs wait for the Apply button.
        this.form.addEventListener('change', (event) => {
          if (event.target.type === 'checkbox') this.submitForm();
        });
        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          this.submitForm();
        });
      }

      // Close an open dropdown when another opens or when clicking outside.
      this.filters = Array.from(this.querySelectorAll('[data-pp-filter]'));
      this.filters.forEach((details) => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          this.filters.forEach((other) => {
            if (other !== details && !other.contains(details)) other.open = false;
          });
        });
      });
      this.onDocumentClick = (event) => {
        this.filters.forEach((details) => {
          if (details.open && !details.contains(event.target)) details.open = false;
        });
      };
      this.onKeydown = (event) => {
        if (event.key !== 'Escape') return;
        this.filters.forEach((details) => {
          if (details.open) {
            details.open = false;
            details.querySelector('summary').focus();
          }
        });
      };
      document.addEventListener('click', this.onDocumentClick);
      document.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
      document.removeEventListener('keydown', this.onKeydown);
    }

    submitForm() {
      const params = new URLSearchParams();
      new FormData(this.form).forEach((value, key) => {
        if (value !== '') params.append(key, value);
      });
      const url = new URL(this.form.action, window.location.origin);
      url.search = params.toString();
      this.go(url);
    }

    go(url) {
      this.classList.add('is-loading');
      window.location.assign(url.toString());
    }
  }

  customElements.define('pp-collection', PpCollection);
})();
